import React from "react";
import Navigation from "../../components/Navigation";
// import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import { User, Car, TrendingUp, Users, Building, ArrowRight } from "lucide-react";
import "./style.css";

const pricingData = [
    {
        title: "Auto Assessments",
        price: "R500*",
        desc: "For individuals with employment income only (e.g. salaried taxpayers).",
        icon: Car,
        slug: "/contact"
    },
    {
        title: "Individual Tax Return",
        price: "R500*",
        desc: "For individuals (e.g. additional income, deductions, investment income).",
        icon: User,
        slug: "/contact"
    },
    {
        title: "Provisional Tax",
        price: "R800*",
        desc: "For provisional taxpayers (2 payments during the year of assessment).",
        icon: TrendingUp,
        slug: "/contact"
    },
    {
        title: "Trust Tax Return",
        price: "R1,200*",
        desc: "All trusts (IT3 returns) for the year of assessment.",
        icon: Users,
        slug: "/contact"
    },
    {
        title: "Companies & Other Returns",
        price: "R1,500*",
        desc: "Comprehensive corporate and business tax return filings.",
        icon: Building,
        slug: "/contact"
    },
];

const Pricing = () => {
    return (
        <div className="pricing-page-wrapper">
            <Navigation />
            <main className="pricing-main">
                {/* Hero Section */}
                <section className="pricing-hero">
                    <div className="container">
                        <h1>Transparent Professional Tax Pricing</h1>
                        <div className="hero-underline"></div>
                        <p>Affordable, transparent, and tailored to your specific tax compliance needs for Tax Season.</p>
                    </div>
                </section>

                {/* Pricing Cards Grid */}
                <section className="pricing-section">
                    <div className="container">
                        <div className="pricing-grid">
                            {pricingData.map((item, index) => {
                                const IconComp = item.icon;
                                return (
                                    <div className="pricing-card" key={index}>
                                        <div className="pricing-icon">
                                            <IconComp size={32} />
                                        </div>
                                        <h3>{item.title}</h3>
                                        <div className="price-tag">
                                            <span className="price-label">From</span>
                                            <span className="price-amount">{item.price}</span>
                                        </div>
                                        <p>{item.desc}</p>
                                        <Link to={item.slug} className="btn-pricing">
                                            Book Service <ArrowRight size={16} />
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="pricing-note">
                            <p>*Prices from. Final fee depends on complexity of your tax affairs.</p>
                        </div>
                    </div>
                </section>
            </main>
            {/* <Footer /> */}
        </div>
    );
};

export default Pricing;